import { Injectable } from '@angular/core';
import { UrlBuilderService } from '@common/services/url-builder.service';

/**
 * Provides urls for pages/resources within the Mojo (Online Forms) application.
 **/
@Injectable()
export class MojoUrlProvider {

  constructor(private readonly urlBuilder: UrlBuilderService) {}

  /**
   * These urls should perhaps be received from a MOJO API call
   */


  /**
   * Url for the currently logged in users 'My Activities' page
   **/
  myActivities(): string {
    return this.urlBuilder.getMojoFormsMyActivitiesUrl();
  }

  newActivity(): string {
    return this.urlBuilder.getMojoFormsNewActivitiesUrl();
  }

  myActivitiesApi(): string {
    return this.urlBuilder.getMojoFormsMyActivitiesApiUrl();
  }

  works(): string {
    return this.urlBuilder.getWorksUrl();
  }
}
